const goodMilk = {
  //美丽天使
  path: 'milk', //办公室
  component: () => import("@/views/member/milk/milk"),
  meta: {
    tabBar: 'home'
  },
  children:[
    {
      // 招募收益
      path: 'award-earnings',
      component: () => import("@/views/member/milk/award-earnings"),
    },
    // {
    //   // 碳分奖励
    //   path: 'carbon-earnings',
    //   component: () => import("@/views/member/milk/carbon-earnings"),
    // },
  ]
};

export default goodMilk;